import { render, staticRenderFns } from "./ScenarioVideoSlide.vue?vue&type=template&id=231bfc6e&scoped=true"
import script from "./ScenarioVideoSlide.vue?vue&type=script&lang=js"
export * from "./ScenarioVideoSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231bfc6e",
  null
  
)

export default component.exports